import { BaseEvent, eventRegistry } from "@Context/common/general/event-context";
import * as t from "io-ts";

// Define the project event type using io-ts
export const ProjectEventType = t.type({
  type: t.union([
    t.literal("timeline_time_change"),
    t.literal("timeline_play"),
    t.literal("timeline_pause"),
    t.literal("timeline_seek"),
    t.literal("player_set"),
  ]),
  matchTime: t.union([t.number, t.undefined]),
  playerId: t.union([t.number, t.undefined]),
  timestamp: t.number,
});

// Type alias for TypeScript
export type ProjectEvent = t.TypeOf<typeof ProjectEventType> & BaseEvent;

// Register project events
const projectEmitter = eventRegistry.registerEventType<typeof ProjectEventType, ProjectEvent>("project", ProjectEventType);

// Helper functions to emit project events
export const projectEvents = {
  emitTimeChange: (matchTime: number, clipId?: number, builderTime?: number) => {
    projectEmitter.emit({
      type: "timeline_time_change",
      matchTime,
      playerId: undefined,
      timestamp: Date.now(),
    });
  },

  emitSeek: (matchTime: number) => {
    projectEmitter.emit({
      type: "timeline_seek",
      matchTime,
      playerId: undefined,
      timestamp: Date.now(),
    });
  },

  emitPlay: (matchTime: number) => {
    projectEmitter.emit({
      type: "timeline_play",
      matchTime,
      playerId: undefined,
      timestamp: Date.now(),
    });
  },

  emitPause: (matchTime: number) => {
    projectEmitter.emit({
      type: "timeline_pause",
      matchTime,
      playerId: undefined,
      timestamp: Date.now(),
    });
  },

  emitSetPlayer: (playerId: number) => {
    projectEmitter.emit({
      type: "player_set",
      matchTime: undefined,
      playerId,
      timestamp: Date.now(),
    });
  },

  // Helper to subscribe to all project events
  onProjectEvent: (callback: (event: ProjectEvent) => void) => {
    return projectEmitter.on(callback);
  },

  // Legacy timeline event subscription for backward compatibility
  onTimelineEvent: (callback: (event: ProjectEvent) => void) => {
    return projectEmitter.on((event) => {
      if (event.type.startsWith("timeline_")) {
        callback(event);
      }
    });
  },
};
